import React from 'react';
import TopHeader from '../top-header/top-header';
import ConcertBanner from '../concert-banner/concert-banner';
import HeroBanner from '../hero-banner/hero-banner';
import LineupSection from '../lineup-section/lineup-section';
import Anniversary from '../anniversary/anniversary';
import GuideSection from '../guide-section/guide-section';
import { SINGERS } from '../../statics/vuon-concert-2025.statics';
import RegisterSection from '../register-section/register-section';
import { ImageRaw } from '../../../../components/image-raw';
import LinearText from '../linear-text/linear-text';

interface Concert2025LayoutProps {
  className?: string;
  children?: React.ReactNode;
}

const Concert2025Layout: React.FC<Concert2025LayoutProps> = ({
  className = '',
  children
}) => {
  return (
    <div className={`min-h-screen flex flex-col ${className}`}>
      {/* Header - Sticky */}
      <TopHeader />
      {/* Main Content */}
      <main className="flex-1">
        {/* 1. Concert Banner (Video teaser) */}
        <section id="concert-banner" className="relative">
          <ConcertBanner />
        </section>

        {/* 2. Hero Banner */}
        <section id="hero-banner" className="relative">
          <HeroBanner />
        </section>

        {/* 3. Lineup Section */}
        <section id="lineup" className="relative">
          <LineupSection singers={SINGERS} />
        </section>

        {/* 4. Anniversary */}
        <section id="anniversary" className="relative">
          <Anniversary
            festivalLogo={
              <div className="w-[455px] h-[294px]">
                <ImageRaw
                  src={'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/festival-logo.png'}
                  alt="Logo Festival"
                  className="h-full w-full object-cover"
                />
              </div>
            }
            aniversaryLogo={
              <div className="w-[674px] h-[269px]">
                <ImageRaw
                  src={'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/aniversary-logo.png'}
                  alt="Logo Festival"
                  className="h-full w-full object-cover"
                />
              </div>
            }
            aniversaryDescription="Trong suốt những năm qua, KidsPlaza đã vinh dự đồng hành cùng Quý khách hàng và Quý đối tác gieo
                                        những hạt mầm ý nghĩa cho hàng triệu gia đình Việt. Năm nay, bước sang mùa Festival thứ 10,
                                        chúng tôi mang đến phiên bản đặc biệt FESTIVAL TREND – “Cùng con vươn mình - Kiến tạo tương
                                        lai”. Không chỉ là một sự kiện thường niên, Festival đã trở thành biểu tượng tiên phong, nơi
                                        khởi nguồn những xu hướng nuôi dạy con hiện đại, kết nối Gen Y và Gen Z – những thế hệ cha mẹ
                                        đầy khát vọng, tự tin và bản lĩnh."
          />
        </section>

        {/* 5. Guideline Section */}
        <section id="guidelines" className="relative">
        <GuideSection guides={[
            {
                title: 'SƠ ĐỒ KHU VỰC SÂN KHẤU',
                titleClassName: 'p-2 text-[24px] font-extrabold text-white',
                content: (
                    <div className="w-full h-full !bg-[#FFF9D7] rounded-b-[16px]">
                        <ImageRaw
                            className="w-full h-full object-contain rounded-b-[16px]"
                            src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/stage_area_map.webp"
                            alt="Sơ đồ khu vực concert"
                        />
                    </div>
                ),
                contentClassName: 'px-[100px]',
                className: 'max-w-[906px]',
            },
            {
                title: 'CHÍNH SÁCH AN TOÀN VÉ KIDSPLAZA',
                titleClassName: 'p-2 text-[24px] font-extrabold text-white',
                content: (
                    <div className="p-3 text-black text-bold text-[12px]">
                        <div className="rounded-md">
                            <LinearText className="font-extrabold font-montserrat text-[16px]">
                                1. KÊNH PHÁT HÀNH VÉ CHÍNH THỨC
                            </LinearText>
                            <ul className="list-[upper-alpha] pl-6 font-bold font-montserrat text-[12px]">
                                <li>
                                    Vé online concert chỉ được phát hành bởi KidsPlaza thông qua link (
                                    <a href="#register-section" className="text-black underline">
                                        Đăng ký vé
                                    </a>
                                    ) và cập nhật tại fanpage{' '}
                                    <a
                                        href="https://www.facebook.com/kidsplaza.com.vn"
                                        className="text-black underline"
                                        target="_blank"
                                        rel="noreferrer">
                                        KidsPlaza
                                    </a>{' '}
                                    (có tích xanh).
                                </li>
                                <li>
                                    BTC gửi vé điện tử trực tiếp qua email/Zalo OA cho khách hàng đăng ký thành công và đủ điều
                                    kiện tham gia qua số điện thoại khách đăng ký theo link.
                                </li>
                                <li>
                                    KidsPlaza khuyến nghị Quý khách hàng không mua vé thông qua các kênh không chính thống. BTC
                                    KHÔNG công nhận và chịu trách nhiệm với vé được cung cấp từ những nguồn khác.
                                </li>
                            </ul>
                        </div>
                        <div className="rounded-md">
                            <LinearText className="font-bold font-montserrat text-[16px]">
                                2. ĐỊNH DANH VÉ - NGĂN CHUYỂN NHƯỢNG, LỪA ĐẢO
                            </LinearText>
                            <ul className="list-[upper-alpha] pl-6 space-y-1 font-bold font-montserrat text-[12px]">
                                <li>Mỗi vé điện tử gắn với 01 mã QR và 01 số điện thoại.</li>
                                <li>
                                    Quý khách hàng sau khi đăng ký vé thành công và nhận được mã xác nhận qua Email và Zalo OA.
                                </li>
                                <li>
                                    Quý khách hàng sau khi nhận được mã vé thành công tiến hành đổi vé cứng tại hệ thống cửa
                                    hàng offline của KidsPlaza như đã đăng ký.
                                </li>
                                <li>
                                    Thời gian và ngày đổi vé cứng sẽ được KidsPlaza gửi tới khách hàng đủ điều kiện qua Email và
                                    Zalo OA đã đăng ký vé concert.
                                </li>
                                <li>Quý khách hàng khi đến check-in tại sự kiện cần xuất trình vé cứng đã được quy đổi.</li>
                                <li>
                                    Mỗi khách hàng chỉ được đăng ký 01 vé duy nhất. Mỗi vé chỉ sử dụng vào cửa duy nhất 01 lần.
                                </li>
                                <li>
                                    Mọi trường hợp cần hỗ trợ vé và thông tin vé concert vui lòng liên hệ hotline KidsPlaza theo
                                    số 18006608 - Nhánh số 3.
                                </li>
                            </ul>
                        </div>
                    </div>
                ),
                contentClassName: ' ',
                className: '',
            },
            {
                title: 'ĐIỀU KHOẢN CHUNG',
                titleClassName: 'p-2 text-[24px] font-extrabold text-white',
                content: (
                    <div className="text-black text-[12px] p-3">
                        <div className="rounded-md">
                            <LinearText className="font-bold font-montserrat text-[16px] mb-2">1. QUY ĐỊNH CHUNG</LinearText>
                            <ul className="list-[upper-alpha] pl-6 space-y-1 font-bold font-montserrat text-[12px]">
                                <li>
                                    Để đảm bảo an ninh cho sự kiện, BTC có quyền kiểm tra tư trang của tất cả người tham dự khi
                                    qua cổng an ninh.
                                </li>
                                <li>
                                    BTC không chịu trách nhiệm đối với các tài sản bị mất, bị đánh cắp hoặc bị hư hỏng. Khuyến
                                    cáo bạn không nên mang theo những đồ có giá trị.
                                </li>
                                <li>
                                    BTC có quyền từ chối hoặc mời ra khỏi khu vực biểu diễn bất cứ cá nhân nào vi phạm quy định.
                                </li>
                                <li>BTC giữ quyền quyết định cuối cùng trong mọi trường hợp.</li>
                            </ul>
                        </div>
                        <div className="rounded-md">
                            <LinearText className="font-bold font-montserrat text-[16px] mb-2">
                                2. QUY ĐỊNH VỀ ĐỐI TƯỢNG THAM DỰ
                            </LinearText>
                            <ul className="list-[upper-alpha] pl-6 space-y-1 font-bold font-montserrat text-[12px]">
                                <li>Chương trình âm nhạc "Vươn concert" chỉ dành cho Quý khách hàng từ 18 tuổi trở lên.</li>
                                <li>
                                    Chương trình không phù hợp cho Quý khách hàng là phụ nữ mang thai và trẻ em dưới 18 tuổi.
                                </li>
                            </ul>
                        </div>
                    </div>
                ),
                contentClassName: ' ',
                className: '',
            },
            {
                title: 'QUY ĐỊNH CHECK IN',
                titleClassName: 'p-2 text-[24px] font-extrabold text-white',
                content: (
                    <div className="text-black text-[12px] p-3">
                        <div className="rounded-md">
                            <LinearText className="font-bold font-montserrat text-[16px] mb-2">1. VÉ CỨNG</LinearText>
                            <ul className="list-[upper-alpha] pl-6 space-y-1 font-bold font-montserrat text-[12px]">
                                <li>
                                    Vé check in tham gia sự kiện là bản vé in cứng (bắt buộc còn nguyên vẹn và đúng tiêu chuẩn
                                    theo quy định)
                                </li>
                                <li>
                                    Mỗi vé chỉ có dành 01 lượt vào cổng. Quý khách hàng tự bảo quản vé cứng. BTC không chịu
                                    trách nhiệm trong trường hợp vé bị lộ thông tin check in/ mất/ hỏng.
                                </li>
                            </ul>
                        </div>
                        <div className="rounded-md">
                            <LinearText className="font-bold font-montserrat text-[16px] mb-2">2. VÒNG TAY CHECK IN</LinearText>
                            <ul className="list-[upper-alpha] pl-6 space-y-1 font-bold font-montserrat text-[12px]">
                                <li>
                                    Sau khi xuất trình vé cứng, mỗi khách hàng được đeo 01 vòng tay sử dụng để ra vào nhạc hội
                                    trong thời gian diễn ra concert.
                                </li>
                                <li>Mỗi vé cứng chỉ quy đổi được duy nhất 01 vòng tay áp dụng cho 01 khách hàng.</li>
                                <li>
                                    Vòng tay sẽ chỉ được phát duy nhất 01 lần khi khách thực hiện check in. BTC không chịu trách
                                    nhiệm và có quyền từ chối cho khán giả vào trong khu khán đài biểu diễn trong trường hợp mất
                                    vòng tay.
                                </li>
                            </ul>
                        </div>
                        <div className="rounded-md">
                            <LinearText className="font-bold font-montserrat text-[16px] mb-2">3. LIGHTSTICK</LinearText>
                            <ul className="list-[upper-alpha] pl-6 space-y-1 font-bold font-montserrat text-[12px]">
                                <li>
                                    Tại ngày tham gia sự kiện, Quý khách hàng giữ vé cứng và đổi lấy lightstick miễn phí tại
                                    quầy check in.
                                </li>
                                <li>BTC thu lại sau khi đêm đại nhạc hội kết thúc</li>
                                <li>Số lượng lightstick phát miễn có hạn.</li>
                            </ul>
                        </div>
                    </div>
                ),
                contentClassName: ' ',
                className: '',
            },
            {
                title: 'NỘI QUY THAM DỰ "VƯƠN CONCERT"',
                titleClassName: 'p-2 text-[24px] font-extrabold text-white',
                content: (
                    <div className="text-black font-bold font-montserrat text-[12px] p-3">
                        <ul className="list-decimal pl-6 space-y-1 font-bold font-montserrat text-[12px]">
                            <li>Không mang đồ ăn, chai nước uống (được phép mang nước đựng trong cốc mềm, cốc giấy, túi zip), các loại ghế ngồi từ ngoài vào trong khu vực tổ chức concert.</li>
                            <li>
                                Không mang vũ khí, vật cháy nổ, sắc nhọn, đèn laser, đèn pin, ô dù, bút viết, gậy selfie, chân
                                máy ảnh.
                            </li>
                            <li>Không sử dụng chất cấm, vật dụng gây cháy nổ</li>
                            <li>Không mang bao thuốc lá vào sự kiện</li>
                            <li>Không mang theo động vật hoặc thú cưng</li>
                            <li>Không mang balo/túi xách có kích thước lớn hơn 26x26 cm</li>
                            <li>
                                Không mang áp phích/ bảng cổ vũ/ bảng chỉ dẫn mang tính chất chính trị, ngôn từ không phù hợp
                                thuần phong mỹ tục
                            </li>
                            <li>
                                Không chen lấn, xô đẩy trong lúc diễn ra sự kiện, không được ôm hàng rào và lắc mạnh, gây ảnh
                                hưởng an toàn.
                            </li>
                            <li>
                                Không gây gổ đánh nhau hoặc tham gia vào bất kỳ hành động nào có thể gây hại, gây nguy hiểm, đe
                                dọa hoặc mang lại sự khó chịu cho những người tham dự khác.
                            </li>
                            <li>Không sử dụng chất cấm, vật dụng gây cháy nổ</li>
                        </ul>
                    </div>
                ),
                contentClassName: ' ',
                className: '',
            },
        ]} />
        </section>

        <section id="register" className="relative">
          <RegisterSection />
        </section>

        {/* Additional custom content */}
        {children && (
          <section className="relative">
            {children}
          </section>
        )}
      </main>

      {/* Footer - Can be added when footer component is ready */}
      {/*
      <footer>
        <Footer />
      </footer>
      */}
    </div>
  );
};

export default Concert2025Layout;
